import styled from 'styled-components'

export const SortableShippingMethodContainer = styled.div`
  display: grid;
  grid-template-columns: ${props => props.theme.spacing.sp8} 100%;
  align-items: center;
  gap: ${props => props.theme.spacing.sp16};
  padding-right: ${props => props.theme.spacing.sp32};

  #draggable-icon {
    cursor: grab;
  }

  & > div {
    flex-grow: 1;
  }
`
